export default "__VITE_ASSET__D2vIRki9__"